let Algo, Draw
if(typeof module!=='undefined') {
  Algo = require('./algo')
  Draw = require('./draw')
}else if(typeof window!=='undefined') {
  Algo = window.Algo
  Draw = window.Draw
}

const DopplerDraw = {
  drawBeamOnGround, drawBeam, drawTravelLine, drawBeamGroundUp,
}

if(typeof module!=='undefined') { module.exports = DopplerDraw } else if(typeof window!=='undefined') { window.DopplerDraw = DopplerDraw }

function drawBeamOnGround(dst, rig, x0, y0, z0, h_angle, color='#00FF00') {
  if(!rig) return
  const { radar_yaw, project } = rig
  // display radar beam on each meter from radar sensor
  const distance_start = 1
  const distance_end = 30
  const angle_delta = 1
  const angle_start = radar_yaw - h_angle/2
  const angle_end = radar_yaw + h_angle/2
  const sin_cos = []
  for(let angle=angle_start; angle<angle_end; angle+=angle_delta) {
    const rad = angle * Algo.degrad
    sin_cos.push([Math.sin(rad), Math.cos(rad)])
  }
  sin_cos.push([Math.sin(angle_end*Algo.degrad), Math.cos(angle_end*Algo.degrad)])
  for(let distance=distance_start; distance<=distance_end; distance++) {
    if(distance>15 && distance%5!==0) continue
    const pixels = []
    for(let i=0; i<sin_cos.length; i++) {
      const LAT = -(x0 + distance * sin_cos[i][0])
      const LON = z0 + distance * sin_cos[i][1]
      const p = project([LON, LAT, -y0], true)
      if(distance%5===0) {
        if(i===0) {
          Draw.drawText(dst, distance+' m', 20, p[0]+40, p[1], 'center', color)
        }else if(i===sin_cos.length-1) {
          Draw.drawText(dst, distance+' m', 20, p[0]-40, p[1], 'center', color)
        }
      }
      pixels.push(p)
    }
    for(let i=1; i<pixels.length; i++) {
      const [x1, y1] = pixels[i-1]
      const [x2, y2] = pixels[i]
      Draw.drawLine(dst, x1, y1, x2, y2, color, distance%5===0 ? 3 : 1)
    }
  }

  // display radar beam border and center line
  for(const angle of [angle_start, radar_yaw, angle_end]) {
    const rad = angle * Algo.degrad
    const sin = Math.sin(rad)
    const cos = Math.cos(rad)
    const LAT1 = -(x0 + distance_start * sin)
    const LON1 = z0 + distance_start * cos
    const p1 = project([LON1, LAT1, -y0], true)
    const LAT2 = -(x0 + distance_end * sin)
    const LON2 = z0 + distance_end * cos
    const p2 = project([LON2, LAT2, -y0], true)
    Draw.drawLine(dst, p1[0], p1[1], p2[0], p2[1], color, 2)
  }
} // drawBeamOnGround

function drawBeam(dst, rig, side_distance) {
  const { camera_height, radar_yaw, radar_h_angle, radar_v_angle, camera_radar_side, radar_height, camera_radar_forward, project } = rig
  // calculate radar beam side rectangle
  // radar_v_angle = 5
  const radar_latc = -side_distance - camera_radar_side
  const radar_heightc = camera_height - radar_height
  const radar_lonc = camera_radar_forward + (radar_latc - camera_radar_side) / Math.tan(radar_yaw*Algo.degrad)

  const radar_lon1 = camera_radar_forward + (radar_latc - camera_radar_side) / Math.tan((radar_yaw+radar_h_angle/2)*Algo.degrad)
  const radar_lon2 = camera_radar_forward + (radar_latc - camera_radar_side) / Math.tan((radar_yaw-radar_h_angle/2)*Algo.degrad)
  const radar_height1 = radar_heightc + Math.tan(radar_v_angle/2*Algo.degrad) * Math.sqrt((radar_lonc-camera_radar_forward)**2 + (-side_distance - camera_radar_side)**2)
  const radar_height2 = radar_heightc - Math.tan(radar_v_angle/2*Algo.degrad) * Math.sqrt((radar_lonc-camera_radar_forward)**2 + (-side_distance - camera_radar_side)**2)

  const r1 = [radar_lon1, -radar_latc, -Math.min(camera_height, radar_height1)]
  const r2 = [radar_lon1, -radar_latc, -radar_height2]
  const r3 = [radar_lon2, -radar_latc, -radar_height2]
  const r4 = [radar_lon2, -radar_latc, -Math.min(camera_height, radar_height1)]
  const radar_pixels = [r1, r2, r3, r4].map(p=>project(p, true))
  const lane_width = 3.5
  Draw.drawPolygon(dst, radar_pixels, '#FFDD0040')
  Algo.drawLine(dst, ...r1, ...r2, '#FFDD00', 9+Math.round(2*side_distance/lane_width))
} // drawBeam

function drawTravelLine(dst, rig, lateral, color='#FFDD00', thick=3, label_size, label_thick) {
  const { camera_height, camera_radar_side, project } = rig
  // calculate radar beam side rectangle
  const LAT = -lateral - camera_radar_side
  const HEIGHT = -camera_height
  const LON1 = 1
  const LON2 = 1000000
  const p1 = project([LON1, LAT, HEIGHT], true)
  const p2 = project([LON2, LAT, HEIGHT], true)
  Draw.drawLine(dst, ...p1, ...p2, color, thick)
  if(label_size>0) {
    const m = (p2[1] - p1[1]) / (p2[0] - p1[0])
    const x = 1900
    const y = p1[1] + m * (x - p1[0])
    const text = lateral.toFixed(2) + ' m'
    Draw.drawText(dst, text, label_size, x, y-label_size*1.7, 'right', color, color, label_thick || 1)
    const text2 = (lateral + camera_radar_side).toFixed(1) + ' m'
    Draw.drawText(dst, text2, Math.round(label_size * 0.7), x, y-label_size*0.7, 'right', color, color, label_thick || 1)
  }
  return [p1, p2]
} // drawTravelLine

function drawBeamGroundUp(dst, rig, lateral) {
  const { camera_height, radar_yaw, radar_h_angle, camera_radar_side, camera_radar_forward, project } = rig
  const beam_height = 2
  const LAT = -lateral - camera_radar_side
  const HEIGHT1 = -camera_height
  const HEIGHT2 = -camera_height+beam_height
  const LON = camera_radar_forward + lateral / Math.tan(radar_yaw*Algo.degrad)
  const LON1 = camera_radar_forward + lateral / Math.tan((radar_yaw+radar_h_angle/2)*Algo.degrad)
  const LON2 = camera_radar_forward + lateral / Math.tan((radar_yaw-radar_h_angle/2)*Algo.degrad)

  const r1 = [LON1, LAT, HEIGHT1]
  const r2 = [LON1, LAT, HEIGHT2]
  const r3 = [LON2, LAT, HEIGHT2]
  const r4 = [LON2, LAT, HEIGHT1]
  const radar_pixels = [r1, r2, r3, r4].map(p=>project(p, true))
  Draw.drawPolygon(dst, radar_pixels, '#FFDD0040', '#FFDD00', 2)

  const r = project([LON, LAT, HEIGHT1], true)
  const s = project([LON, LAT, HEIGHT2], true)

  Algo.drawLine(dst, ...r, ...s, '#FF0000', 3)
} // drawBeamGroundUp
